import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="30%" align="left" valign="center"
                                                            className="green_curve">Area
                                                        </th>
                                                        <th width="35%" align="left" valign="top">Your Approach
                                                            to Role Modelling
                                                        </th>
                                                        <th width="40%" align="left" valign="top"
                                                            className=" green_curve1">Considerations
                                                        </th>


                                                    </tr>

                                                    <tr>
                                                        <td width="30%" align="left" valign="center"
                                                            className="lightgreen ">
                                                            <div className="">Positive behaviour</div>
                                                        </td>

                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>You are focused on
                                                            ensuring that
                                                            you carry out tasks and activities
                                                            using good behaviours. This may
                                                            vary from task to task but you
                                                            will always try to ensure that you
                                                            do things in the best possible
                                                            way to set an example for those
                                                            around you.</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>Consider how much of an
                                                            example you are setting to
                                                            others and whether the
                                                            behaviours you are using are the
                                                            most appropriate for each
                                                            situation. Also bear in mind how
                                                            effective these are in achieving
                                                            the end result and reaching high
                                                            quality levels.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="30%" align="left" valign="center"
                                                            className="darkgreen ">
                                                            <div className="">Integrity</div>
                                                        </td>

                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen "><p>Your main aim as a role
                                                            model is
                                                            to maintain a high profile in order
                                                            that others can see what you do
                                                            and adapt their behaviour
                                                            accordingly. Your role could be to
                                                            portray a certain approach or to
                                                            behave in a particular manner.</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen "><p>Consider what you are
                                                            making
                                                            visible to others. Are you
                                                            showing people that you adhere
                                                            to a set of clear values? What
                                                            are the positive behaviours that
                                                            you are portraying? How do you
                                                            show success in a way that will
                                                            inspire others?</p>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Area</th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Positive behaviour</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Your Approach to Role
                                                            Modelling
                                                        </td>
                                                        <td valign="top"><p>You are focused on ensuring that
                                                            you carry out tasks and activities
                                                            using good behaviours. This may
                                                            vary from task to task but you
                                                            will always try to ensure that you
                                                            do things in the best possible
                                                            way to set an example for those
                                                            around you.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg"
                                                            id="m-border-radius">Considerations
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>Consider how much of an example you are setting
                                                                to others and whether the behaviours you are
                                                                using are the most appropriate for each
                                                                situation. Also bear in mind how effective these
                                                                are in achieving the end result and reaching
                                                                high quality levels.</p>

                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Area</th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Quality</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Your Approach to Role
                                                            Modelling
                                                        </td>
                                                        <td valign="top" className="darkgreen">
                                                            <p>Your main aim as a role model is to maintain a
                                                                high profile in order that others can see what
                                                                you do and adapt their behaviour accordingly.
                                                                Your role could be to portray a certain approach
                                                                or to behave in a particular manner.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg"
                                                            id="m-border-radius">Considerations
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>Consider what you are making visible to others.
                                                                Are you showing people that you adhere to a set
                                                                of clear values? What are the positive
                                                                behaviours that you are portraying? How do you
                                                                show success in a way that will inspire
                                                                others?</p>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="lightgreencontentbg  uiheading greennumberroundbg1">
                                                <p>Now consider how you can capitalise on your preferred
                                                    approach to be the most effective
                                                    role model possible and how you can take the other aspects
                                                    into account, or develop
                                                    these areas.</p>
                                            </div>
                                            <br/>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now that you have considered the factors involved in being an
                                                effective role model and have
                                                some practical tools to consider, it is worth thinking about
                                                what to do next. Here are a number of
                                                suggestions to maintain momentum:</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to benchmark your current performance
                                                by asking for formal or
                                                informal feedback.</p>
                                            <div className="border_subtitle">Seek out role models</div>
                                            <p>Consider who the role models are in your life and your
                                                organisation. Once you have identified the
                                                people and their various aspects that you admire or would
                                                like to emulate, think about what it is
                                                particularly that you admire about them or their approach.
                                                You may then want to think about how
                                                you compare. This may seem daunting if you feel that there
                                                is a big gap but this is the starting
                                                point for you to develop a plan to improve.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use the tool in this document to highlight your role model
                                                approach. Once you have established
                                                your preferences you could put together a focused
                                                development plan to improve your effectiveness
                                                as a role model for others. </p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about the opportunities that you have in your current
                                                work, or beyond, where you can
                                                practise role modelling good behaviour or improving your
                                                profile.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}